import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { SeFeApiService } from 'se-fe-api'
import { Affiliation } from 'se-resource-types/dist/lib/BossService'
import { nginV2Headers } from '@se-po/shared-data-access-models'

@Injectable({
  providedIn: 'root'
})
export class AffiliationService {
  public endpoint = 'affiliations'

  constructor(
    private api: SeFeApiService
  ) {
    // noop
  }

  public findAll(orgId: string): Observable<Affiliation[]> {
    return this.api.get<Affiliation[]>(this.endpoint, { params: { ancestor_organization_id: orgId, per_page: 1 }, headers: nginV2Headers })
      .pipe(
        map(response => response.result)
      )
  }
}
